import { AnyUserAssignmentsConfig } from './assignments/AnyUserAssignmentsConfig'
import { PrivacyTermsConfig } from './privacyTerms/PrivacyTermsConfig'
import { ContactConfig } from './contact/ContactConfig'

export const anyUserConfig = [
    AnyUserAssignmentsConfig,
    PrivacyTermsConfig,
    ContactConfig
]